import React from 'react';
import Coverflow from 'react-coverflow';

const WebCarousel = (props) => {
  const fn = function () {
  }

  return(
    <Coverflow
      width={960}
      height={480}
      displayQuantityOfSide={2}
      navigation={false}
      enableHeading={false}
    >
      <div
        onClick={() => fn()}
        onKeyDown={() => fn()}
        role="menuitem"
        tabIndex="0"
      >
      </div>
      <img src='https://i.ibb.co/SQc6YqQ/Screen-Shot-2022-06-24-at-5-41-05-PM.png' alt='spongebob' onClick={(e)=>props.setImageFile(e.target.src)} />
      <img src='https://i.ibb.co/TrqPtZn/Screen-Shot-2022-06-24-at-5-42-49-PM.png' alt='lotr' onClick={(e)=>props.setImageFile(e.target.src)}/>
      <img src='https://i.ibb.co/Kw99GvT/Screen-Shot-2022-06-24-at-2-29-34-PM.png' alt='bernie' onClick={(e)=>props.setImageFile(e.target.src)}/>
      <img src='https://i.ibb.co/3y2vmjF/Screen-Shot-2022-06-24-at-4-53-38-PM.png' alt='creepygirl' onClick={(e)=>props.setImageFile(e.target.src)}/>
      <img src='https://i.ibb.co/S3SfTk4/Screen-Shot-2022-06-24-at-5-42-27-PM.png' alt='invincible' onClick={(e)=>props.setImageFile(e.target.src)}/>
      <img src='https://i.ibb.co/znJ12VD/Screen-Shot-2022-06-24-at-5-41-54-PM.png' alt='yeeesh' onClick={(e)=>props.setImageFile(e.target.src)}/>
    </Coverflow>
  )
}

export default WebCarousel;
